var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValuePropReviews = function SvgValuePropReviews(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 18.0015V27.75H45V18.0015C45 15.5205 42.9795 13.5 40.4985 13.5H19.5V16.5H40.4985C41.3265 16.5 42 17.1735 42 18.0015ZM19.5 23.25H36V20.25H19.5V23.25ZM30 29.25V26.25H9V29.25H30ZM39 35.25H9V32.25H39V35.25ZM4.503 43.5H43.497C44.325 43.5 44.9985 42.828 45 42H3C3.0015 42.828 3.675 43.5 4.503 43.5ZM45 33.75V39H48V41.997C48 44.4795 45.9795 46.5 43.497 46.5H4.503C2.0205 46.5 0 44.4795 0 41.997V39H3V24.9375H6V39H42V33.75H45Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55824 11.1489L7.74624 10.9689L8.25624 9.88141L9.00024 8.29591L9.74424 9.88141L10.2542 10.9689L11.4422 11.1489L13.3322 11.4369L11.8907 12.9174L11.0957 13.7289L11.2787 14.8494L11.5952 16.7889L10.0892 15.9564L9.00024 15.3549L7.91124 15.9564L6.40374 16.7889L6.72024 14.8494L6.90324 13.7289L6.10974 12.9174L4.66824 11.4369L6.55824 11.1489ZM3.43824 20.9994L9.00024 17.9259L14.5622 20.9994L13.5002 14.4879L18.0002 9.87541L11.7812 8.9259L9.00024 2.9994L6.21774 8.9259L0.000244141 9.87541L4.50024 14.4879L3.43824 20.9994Z",
    fill: "#0157FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValuePropReviews);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "value_prop_reviews.a9b5ebd5c3dc09b26b76ef16ffbd0011.svg";